import { LoadingOutlined } from '@ant-design/icons'
import {
  PointCloudContextProvider,
  usePointCloudContext,
} from 'features/pointClouds'
import { AlertsSection } from 'pages/pointClouds/components/alerts/AlertSection'
import { Hud } from 'pages/pointClouds/components/hud/Hud'
import { SIDEBAR_WIDTH } from 'pages/pointClouds/PointCloudSidebar'
import { PointCloudWrapper } from 'pages/pointClouds/PointCloudWrapper'
import React from 'react'
import styled from 'styled-components'

const MainContentContainer = styled.div<{ $sidebarCollapsed: boolean }>`
  position: absolute;
  top: 0;
  left: ${({ $sidebarCollapsed }) => ($sidebarCollapsed ? 0 : SIDEBAR_WIDTH)}px;
  right: 0;
  bottom: 0;
  transition: left 0.3s ease;
`

interface PointCloudViewProps {
  siteID: string
  pointCloudIDs?: string[]
}

const PointCloudViewContent = () => {
  const { isLoadingPotreePointClouds, isSidebarCollapsed } =
    usePointCloudContext()

  if (isLoadingPotreePointClouds) {
    return <LoadingOutlined />
  }

  return (
    <>
      <MainContentContainer $sidebarCollapsed={isSidebarCollapsed}>
        <PointCloudWrapper />
        <Hud />
      </MainContentContainer>
      <AlertsSection />
    </>
  )
}

export const PointCloudView: React.FC<PointCloudViewProps> = ({
  siteID,
  pointCloudIDs,
}) => {
  return (
    <PointCloudContextProvider siteID={siteID} pointCloudIDs={pointCloudIDs}>
      <PointCloudViewContent />
    </PointCloudContextProvider>
  )
}
